import api from "./api";
import {errorBag} from "../assets/functions";

// Сите ЕЛС повици сами си ги обработуваат грешките (409/422 треба да се разликуваат).
const RAW = {skipErrorHandler: true};

let optionsCache = null;

// Статични податоци - се кешираат за сесијата.
export function elsOptions() {
    if (!optionsCache)
        optionsCache = api.get("/els/options", RAW)
            .then(a => a.data.data)
            .catch(e => {
                optionsCache = null;
                throw e;
            });
    return optionsCache;
}

/**
 * Состојбата на нарачката плус податоците за корисникот. ЕЛС совпаѓањето
 * (место/улица) е по адреса, па се повикува повторно кога операторот менува адреса.
 */
export function elsShow(orderId, params) {
    return api.get("/els/orders/" + orderId, {...RAW, params: params || {}})
        .then(a => a.data.data);
}

export function elsQuote(orderId, form, config) {
    return api.post("/els/orders/" + orderId + "/quote", form, {...RAW, ...config})
        .then(a => a ? a.data.data : null);
}

export function elsBook(orderId, form) {
    return api.post("/els/orders/" + orderId, form, RAW).then(a => a.data.data);
}

/**
 * Ја откажува пратката кај ЕЛС и ја брише врската. Без force, 409 значи дека
 * ЕЛС одбил (пратката е веќе подигната) - тогаш прво се поништува во ЕЛС порталот.
 * Со force врската се брише без разлика дали ЕЛС ја откажал.
 */
export function elsVoid(orderId, force) {
    return api.delete("/els/orders/" + orderId, {...RAW, params: force ? {force: 1} : {}})
        .then(a => {
            const body = a.data || {};
            return body.data || body;
        });
}

export function elsStatus(orderId) {
    return api.get("/els/orders/" + orderId + "/status", RAW).then(a => a.data.data);
}

export function elsDetails(orderId) {
    return api.get("/els/orders/" + orderId + "/details", RAW).then(a => a.data.data);
}

/**
 * Пребарување на места (/els/places) и улици (/els/places/{id}/streets).
 * Празен резултат е валиден одговор, не грешка - Скопје постои само по општини.
 * Враќа null ако барањето е откажано.
 */
export function elsSearch(url, q, config) {
    return api.get(url, {...RAW, ...config, params: {q: q}})
        .then(a => {
            if (!a) return null;
            const items = a.data.data || [];
            // Местата враќаат pagination.total, улиците total.
            const total = a.data.total != null
                ? a.data.total
                : (a.data.pagination && a.data.pagination.total);
            return {items: items, total: total == null ? items.length : total};
        });
}

export const ELS_MAX_LABELS = 200;

/**
 * Етикетите се бинарни и бараат Authorization заглавие, па <a href> / window.open враќа 401.
 * Враќа {url, ids} - url е blob кој повикувачот мора да го ослободи со URL.revokeObjectURL.
 *
 * Еден документ е една ЕЛС сметка - серверот печати само пратки од сметката што
 * ги држи, па изборот се групира по сметка пред печатење.
 */
export async function elsLabels(orderIds, documentType = "address-book", account = null) {
    const res = await fetch(api.defaults.baseURL + "/els/labels", {
        method: "POST",
        headers: {
            // Токенот во localStorage веќе го содржи "Bearer " префиксот.
            "Authorization": localStorage.getItem("user-token"),
            "Content-Type": "application/json;charset=utf-8"
        },
        body: JSON.stringify({order_ids: orderIds, document: documentType, account: account})
    });

    if (!res.ok) {
        const body = await res.json().catch(() => null);
        const error = new Error(labelsMessage(res.status, body));
        error.status = res.status;
        throw error;
    }

    const ids = (res.headers.get("X-Els-Shipment-Ids") || "").split(",").filter(a => a);
    return {url: URL.createObjectURL(await res.blob()), ids: ids};
}

function labelsMessage(status, body) {
    if (body && body.errors) return errorBag(body);
    if (body && body.message) return body.message;
    switch (status) {
        case 401:
            return "Сесијата е истечена, најавете се повторно";
        case 404:
            return "Овој формат на етикета не е поддржан од ЕЛС";
        case 422:
            return "Ниту една од избраните нарачки не е испратена преку ЕЛС";
        default:
            return "Неуспешно преземање на етикетите (" + status + ")";
    }
}

// Чиста порака за корисник од ЕЛС грешка.
export function elsError(error) {
    if (!error) return null;
    if (api.isCancel(error)) return null;
    const res = error.response;
    if (!res) return error.message || "Проблем со врската со серверот";
    const data = res.data || {};
    if (data.errors) return errorBag(data);
    if (data.message) return data.message;
    switch (res.status) {
        case 409:
            return "Нарачката е веќе испратена преку ЕЛС";
        case 422:
            return "Нарачката не е на ЕЛС начин на достава или податоците се невалидни";
        case 404:
            return "Не е пронајдено";
        default:
            return "Грешка при повик кон ЕЛС (" + res.status + ")";
    }
}
